/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */

import TextField from "@mui/material/TextField";
import Alert from "@mui/material/Alert";
import Autocomplete from "@mui/material/Autocomplete";
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { useState, state, forwardRef, useImperativeHandle } from "react";
import toast from "react-hot-toast";
import { map, find } from "lodash";

import Button from "@mui/material/Button";

const DesarrolloMotor = forwardRef(
  ({ Back, Next, props, vista = "registrar", desactivar }, ref) => {
    // Campos de desarrollo
    const [EdadSostuvoCabeza, setEdadSostuvoCabeza] = useState(
      props?.edadSostuvoCabeza ? props.edadSostuvoCabeza : ""
    );
    const [EdadGateo, setEdadGateo] = useState(props?.edadGateo ? props.edadGateo : "");
    const [EdadSento, setEdadSento] = useState(props?.edadSento ? props.edadSento : "");
    const [EdadParo, setEdadParo] = useState(props?.edadParo ? props.edadParo : "");
    const [EdadCamino, setEdadCamino] = useState(props?.edadCamino ? props.edadCamino : "");
    const [EdadGiros, setEdadGiros] = useState(props?.edadGiros ? props.edadGiros : "");
    const [EdadComio, setEdadComio] = useState(props?.edadComio ? props.edadComio : "");
    const [EdadBano, setEdadBano] = useState(props?.edadBano ? props.edadBano : "");
    const [EdadSonrisaSocial, setEdadSonrisaSocial] = useState(
      props?.edadSonrisaSocial ? props.edadSonrisaSocial : ""
    );
    const [EdadBalbuceo, setEdadBalbuceo] = useState(props?.edadBalbuceo ? props.edadBalbuceo : "");
    const [EdadPrimerasPalabras, setEdadPrimerasPalabras] = useState(
      props?.edadPrimerasPalabras ? props.edadPrimerasPalabras : ""
    );
    const [EdadObjetosSimples, setEdadObjetosSimples] = useState(
      props?.edadObjetosSimples ? props.edadObjetosSimples : ""
    );
    const [ContactoVisual, setContactoVisual] = useState(props?.contactoVisual ?? null);
    const [DedoApuntar, setDedoApuntar] = useState(props?.dedoApuntar ?? null);
    const [IdComunicacionBuscada, setIdComunicacionBuscada] = useState(
      props?.idComunicacionBuscada ? props.idComunicacionBuscada : null
    );

    // Validadores
    const [isvalid_EdadSostuvoCabeza, isvalid_setEdadSostuvoCabeza] = useState(false);
    const [isvalid_EdadGateo, isvalid_setEdadGateo] = useState(false);
    const [isvalid_EdadSento, isvalid_setEdadSento] = useState(false);
    const [isvalid_EdadParo, isvalid_setEdadParo] = useState(false);
    const [isvalid_EdadCamino, isvalid_setEdadCamino] = useState(false);
    const [isvalid_EdadGiros, isvalid_setEdadGiros] = useState(false);
    const [isvalid_EdadComio, isvalid_setEdadComio] = useState(false);
    const [isvalid_EdadBano, isvalid_setEdadBano] = useState(false);
    const [isvalid_EdadSonrisaSocial, isvalid_setEdadSonrisaSocial] = useState(false);
    const [isvalid_EdadBalbuceo, isvalid_setEdadBalbuceo] = useState(false);
    const [isvalid_EdadPrimerasPalabras, isvalid_setEdadPrimerasPalabras] = useState(false);
    const [isvalid_EdadObjetosSimples, isvalid_setEdadObjetosSimples] = useState(false);
    const [isvalid_ContactoVisual, isvalid_setContactoVisual] = useState(false);
    const [isvalid_DedoApuntar, isvalid_setDedoApuntar] = useState(false);
    const [isvalid_IdComunicacionBuscada, isvalid_setIdComunicacionBuscada] = useState(false);

    const ValidaForm = () => {
      if (!EdadSostuvoCabeza) {
        toast.error("Edad a la que sostuvo su cabeza: Campo obligatorio *");
        isvalid_setEdadSostuvoCabeza(true);
        return null;
      }

      if (!EdadGateo) {
        toast.error("Edad a la que gateó: Campo obligatorio *");
        isvalid_setEdadGateo(true);
        return null;
      }

      if (!EdadSento) {
        toast.error("Edad a la que se sentó: Campo obligatorio *");
        isvalid_setEdadSento(true);
        return null;
      }

      if (!EdadParo) {
        toast.error("Edad a la que paró: Campo obligatorio *");
        isvalid_setEdadParo(true);
        return null;
      }

      if (!EdadCamino) {
        toast.error("Edad a la que caminó: Campo obligatorio *");
        isvalid_setEdadCamino(true);
        return null;
      }

      if (!EdadGiros) {
        toast.error("Edad en la que giró: Campo obligatorio *");
        isvalid_setEdadGiros(true);
        return null;
      }

      if (!EdadComio) {
        toast.error("Edad en la que comenzó a comer: Campo obligatorio *");
        isvalid_setEdadComio(true);
        return null;
      }

      if (!EdadBano) {
        toast.error("Edad en la que empezó a bañarse solo: Campo obligatorio *");
        isvalid_setEdadBano(true);
        return null;
      }

      if (!EdadSonrisaSocial) {
        toast.error("Edad a la que sonrió socialmente: Campo obligatorio *");
        isvalid_setEdadSonrisaSocial(true);
        return null;
      }

      if (!EdadBalbuceo) {
        toast.error("Edad a la que comenzó a balbucear: Campo obligatorio *");
        isvalid_setEdadBalbuceo(true);
        return null;
      }

      if (!EdadPrimerasPalabras) {
        toast.error("Edad de las primeras palabras: Campo obligatorio *");
        isvalid_setEdadPrimerasPalabras(true);
        return null;
      }

      if (!EdadObjetosSimples) {
        toast.error("Edad en la que manipuló objetos simples: Campo obligatorio *");
        isvalid_setEdadObjetosSimples(true);
        return null;
      }

      if (ContactoVisual == null) {
        toast.error("¿Establece contacto visual?: Campo obligatorio *");
        isvalid_setContactoVisual(true);
        return null;
      }

      if (DedoApuntar == null) {
        toast.error("¿Señala con el dedo para mostrar lo que quiere?: Campo obligatorio *");
        isvalid_setDedoApuntar(true);
        return null;
      }

      if (IdComunicacionBuscada == null) {
        toast.error("¿La comunicación es buscada por el niño?: Campo obligatorio *");
        isvalid_setIdComunicacionBuscada(true);
        return null;
      }

      const datosDesarrollo = {
        edadSostuvoCabeza: EdadSostuvoCabeza,
        edadGateo: EdadGateo,
        edadSento: EdadSento,
        edadParo: EdadParo,
        edadCamino: EdadCamino,
        edadGiros: EdadGiros,
        edadComio: EdadComio,
        edadBano: EdadBano,
        edadSonrisaSocial: EdadSonrisaSocial,
        edadBalbuceo: EdadBalbuceo,
        edadPrimerasPalabras: EdadPrimerasPalabras,
        edadObjetosSimples: EdadObjetosSimples,
        contactoVisual: ContactoVisual,
        dedoApuntar: DedoApuntar,
        idComunicacionBuscada: IdComunicacionBuscada,
      };

      Next(datosDesarrollo);
      return datosDesarrollo;
    };

    //Métodos para guardar los datos editados:
    useImperativeHandle(ref, () => ({
      ejecutarNext: () => {
        return ValidaForm();
      },
    }));

    const handleBack = () => {
      const data = {
        edadSostuvoCabeza: EdadSostuvoCabeza,
        edadGateo: EdadGateo,
        edadSento: EdadSento,
        edadParo: EdadParo,
        edadCamino: EdadCamino,
        edadGiros: EdadGiros,
        edadComio: EdadComio,
        edadBano: EdadBano,
        edadSonrisaSocial: EdadSonrisaSocial,
        edadBalbuceo: EdadBalbuceo,
        edadPrimerasPalabras: EdadPrimerasPalabras,
        edadObjetosSimples: EdadObjetosSimples,
        contactoVisual: ContactoVisual,
        dedoApuntar: DedoApuntar,
        idComunicacionBuscada: IdComunicacionBuscada,
      };

      Back(data);
    };

    return (
      <>
        <Grid container spacing={2}>
          {/* Edad a la que sostuvo su cabeza */}
          <Grid item xs={12} md={3} lg={3}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                Edad a la que sostuvo su cabeza (meses):
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={9} lg={9}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={4} lg={4}>
                <TextField
                  fullWidth
                  variant="outlined"
                  disabled={desactivar}
                  size="small"
                  autoComplete="off"
                  value={EdadSostuvoCabeza}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d*$/.test(value)) {
                      setEdadSostuvoCabeza(value);
                    }
                  }}
                  error={isvalid_EdadSostuvoCabeza}
                  helperText={isvalid_EdadSostuvoCabeza ? "Campo obligatorio *" : ""}
                  onFocus={() => isvalid_setEdadSostuvoCabeza(false)}
                  onBlur={() => {
                    if (!EdadSostuvoCabeza) isvalid_setEdadSostuvoCabeza(true);
                  }}
                  inputProps={{
                    inputMode: "numeric", // Muestra teclado numérico en móviles
                    pattern: "[0-9]*", // Sugiere sólo números
                  }}
                />
              </Grid>
              <Grid item xs={12} md={4} lg={4}>
                <MDBox textAlign="right">
                  <MDTypography
                    variant="h6"
                    color="white"
                    style={{ opacity: 0.7, fontSize: "0.9rem" }}
                  >
                    Edad a la que gateó:
                  </MDTypography>
                </MDBox>
              </Grid>
              <Grid item xs={12} md={4} lg={4}>
                <TextField
                  fullWidth
                  variant="outlined"
                  disabled={desactivar}
                  size="small"
                  autoComplete="off"
                  value={EdadGateo}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d*$/.test(value)) {
                      setEdadGateo(value);
                    }
                  }}
                  error={isvalid_EdadGateo}
                  helperText={isvalid_EdadGateo ? "Campo obligatorio *" : ""}
                  onFocus={() => {
                    isvalid_setEdadGateo(false);
                    if (!EdadSostuvoCabeza) {
                      isvalid_setEdadSostuvoCabeza(true);
                    }
                  }}
                  onBlur={() => {
                    if (!EdadGateo) isvalid_setEdadGateo(true);
                  }}
                  style={{ width: "100%", marginBottom: "1rem" }}
                  inputProps={{
                    inputMode: "numeric", // Muestra teclado numérico en móviles
                    pattern: "[0-9]*", // Sugiere sólo números
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Grid container spacing={2}>
          {/* Edad en la que se paró */}
          <Grid item xs={12} md={3} lg={3}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                Edad en la que se paró:
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={9} lg={9}>
            <TextField
              fullWidth
              variant="outlined"
              disabled={desactivar}
              size="small"
              autoComplete="off"
              value={EdadParo}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d*$/.test(value)) {
                  setEdadParo(value);
                }
              }}
              error={isvalid_EdadParo}
              helperText={isvalid_EdadParo ? "Campo obligatorio *" : ""}
              onFocus={() => {
                isvalid_setEdadParo(false);
                if (!EdadSostuvoCabeza) {
                  isvalid_setEdadSostuvoCabeza(true);
                }
                if (!EdadGateo) {
                  isvalid_setEdadGateo(true);
                }
              }}
              onBlur={() => {
                if (!EdadParo) isvalid_setEdadParo(true);
              }}
              style={{ width: "100%", marginBottom: "1rem" }}
              inputProps={{
                inputMode: "numeric", // Muestra teclado numérico en móviles
                pattern: "[0-9]*", // Sugiere sólo números
              }}
            />
          </Grid>
        </Grid>

        {/* Edad a la que se sentó y caminó */}
        <Grid container spacing={2}>
          <Grid item xs={12} md={3} lg={3}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                Edad a la que se sentó (meses):
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={9} lg={9}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={4} lg={4}>
                <TextField
                  fullWidth
                  variant="outlined"
                  disabled={desactivar}
                  size="small"
                  autoComplete="off"
                  value={EdadSento}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d*$/.test(value)) {
                      setEdadSento(value);
                    }
                  }}
                  error={isvalid_EdadSento}
                  helperText={isvalid_EdadSento ? "Campo obligatorio *" : ""}
                  onFocus={() => {
                    isvalid_setEdadSento(false);
                    if (!EdadSostuvoCabeza) {
                      isvalid_setEdadSostuvoCabeza(true);
                    }
                    if (!EdadGateo) {
                      isvalid_setEdadGateo(true);
                    }
                    if (!EdadParo) {
                      isvalid_setEdadParo(true);
                    }
                  }}
                  onBlur={() => {
                    if (!EdadSento) isvalid_setEdadSento(true);
                  }}
                  style={{ width: "100%", marginBottom: "1rem" }}
                  inputProps={{
                    inputMode: "numeric", // Muestra teclado numérico en móviles
                    pattern: "[0-9]*", // Sugiere sólo números
                  }}
                />
              </Grid>
              <Grid item xs={12} md={4} lg={4}>
                <MDBox textAlign="right">
                  <MDTypography
                    variant="h6"
                    color="white"
                    style={{ opacity: 0.7, fontSize: "0.9rem" }}
                  >
                    Edad a la que caminó:
                  </MDTypography>
                </MDBox>
              </Grid>
              <Grid item xs={12} md={4} lg={4}>
                <TextField
                  fullWidth
                  variant="outlined"
                  disabled={desactivar}
                  size="small"
                  autoComplete="off"
                  value={EdadCamino}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d*$/.test(value)) {
                      setEdadCamino(value);
                    }
                  }}
                  error={isvalid_EdadCamino}
                  helperText={isvalid_EdadCamino ? "Campo obligatorio *" : ""}
                  onFocus={() => {
                    isvalid_setEdadCamino(false);
                    if (!EdadSostuvoCabeza) {
                      isvalid_setEdadSostuvoCabeza(true);
                    }
                    if (!EdadGateo) {
                      isvalid_setEdadGateo(true);
                    }
                    if (!EdadParo) {
                      isvalid_setEdadParo(true);
                    }
                    if (!EdadSento) {
                      isvalid_setEdadSento(true);
                    }
                  }}
                  onBlur={() => {
                    if (!EdadCamino) isvalid_setEdadCamino(true);
                  }}
                  style={{ width: "100%", marginBottom: "1rem" }}
                  inputProps={{
                    inputMode: "numeric", // Muestra teclado numérico en móviles
                    pattern: "[0-9]*", // Sugiere sólo números
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        {/* Edad en la que comenzó rodamiento o giros */}
        <Grid container spacing={2}>
          <Grid item xs={12} md={3} lg={3}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                Edad en la que comenzó rodamiento o giros
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={9} lg={9}>
            <TextField
              fullWidth
              variant="outlined"
              disabled={desactivar}
              size="small"
              autoComplete="off"
              value={EdadGiros}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d*$/.test(value)) {
                  setEdadGiros(value);
                }
              }}
              error={isvalid_EdadGiros}
              helperText={isvalid_EdadGiros ? "Campo obligatorio *" : ""}
              onFocus={() => {
                isvalid_setEdadGiros(false);
                if (!EdadSostuvoCabeza) {
                  isvalid_setEdadSostuvoCabeza(true);
                }
                if (!EdadGateo) {
                  isvalid_setEdadGateo(true);
                }
                if (!EdadParo) {
                  isvalid_setEdadParo(true);
                }
                if (!EdadSento) {
                  isvalid_setEdadSento(true);
                }
                if (!EdadCamino) {
                  isvalid_setEdadCamino(true);
                }
              }}
              onBlur={() => {
                if (!EdadGiros) isvalid_setEdadGiros(true);
              }}
              style={{ width: "100%", marginBottom: "1rem" }}
              inputProps={{
                inputMode: "numeric", // Muestra teclado numérico en móviles
                pattern: "[0-9]*", // Sugiere sólo números
              }}
            />
          </Grid>
        </Grid>

        {/* Edad comió solo / control de esfínteres */}
        <Grid container spacing={2}>
          <Grid item xs={12} md={3} lg={3}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                Edad a la que comió por si solo (meses):
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={9} lg={9}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={4} lg={4}>
                <TextField
                  fullWidth
                  variant="outlined"
                  disabled={desactivar}
                  size="small"
                  autoComplete="off"
                  value={EdadComio}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d*$/.test(value)) {
                      setEdadComio(value);
                    }
                  }}
                  error={isvalid_EdadComio}
                  helperText={isvalid_EdadComio ? "Campo obligatorio *" : ""}
                  onFocus={() => {
                    isvalid_setEdadComio(false);
                    if (!EdadSostuvoCabeza) {
                      isvalid_setEdadSostuvoCabeza(true);
                    }
                    if (!EdadGateo) {
                      isvalid_setEdadGateo(true);
                    }
                    if (!EdadParo) {
                      isvalid_setEdadParo(true);
                    }
                    if (!EdadSento) {
                      isvalid_setEdadSento(true);
                    }
                    if (!EdadCamino) {
                      isvalid_setEdadCamino(true);
                    }
                    if (!EdadGiros) {
                      isvalid_setEdadGiros(true);
                    }
                  }}
                  onBlur={() => {
                    if (!EdadComio) isvalid_setEdadComio(true);
                  }}
                  style={{ width: "100%", marginBottom: "1rem" }}
                  inputProps={{
                    inputMode: "numeric", // Muestra teclado numérico en móviles
                    pattern: "[0-9]*", // Sugiere sólo números
                  }}
                />
              </Grid>
              <Grid item xs={12} md={4} lg={4}>
                <MDBox textAlign="right">
                  <MDTypography
                    variant="h6"
                    color="white"
                    style={{ opacity: 0.7, fontSize: "0.9rem" }}
                  >
                    Edad a la que comenzó a ir al baño (control de esfínteres):
                  </MDTypography>
                </MDBox>
              </Grid>
              <Grid item xs={12} md={4} lg={4}>
                <TextField
                  fullWidth
                  variant="outlined"
                  disabled={desactivar}
                  size="small"
                  autoComplete="off"
                  value={EdadBano}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d*$/.test(value)) {
                      setEdadBano(value);
                    }
                  }}
                  error={isvalid_EdadBano}
                  helperText={isvalid_EdadBano ? "Campo obligatorio *" : ""}
                  onFocus={() => {
                    isvalid_setEdadBano(false);
                    if (!EdadSostuvoCabeza) {
                      isvalid_setEdadSostuvoCabeza(true);
                    }
                    if (!EdadGateo) {
                      isvalid_setEdadGateo(true);
                    }
                    if (!EdadParo) {
                      isvalid_setEdadParo(true);
                    }
                    if (!EdadSento) {
                      isvalid_setEdadSento(true);
                    }
                    if (!EdadCamino) {
                      isvalid_setEdadCamino(true);
                    }
                    if (!EdadGiros) {
                      isvalid_setEdadGiros(true);
                    }
                    if (!EdadComio) {
                      isvalid_setEdadComio(true);
                    }
                  }}
                  onBlur={() => {
                    if (!EdadBano) isvalid_setEdadBano(true);
                  }}
                  style={{ width: "100%", marginBottom: "1rem" }}
                  inputProps={{
                    inputMode: "numeric", // Muestra teclado numérico en móviles
                    pattern: "[0-9]*", // Sugiere sólo números
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        {/* Edad sonrisa social / balbuceo */}
        <Grid container spacing={2}>
          <Grid item xs={12} md={3} lg={3}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                Edad en la que comenzó con sonrisa social
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={9} lg={9}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={4} lg={4}>
                <TextField
                  fullWidth
                  variant="outlined"
                  disabled={desactivar}
                  size="small"
                  autoComplete="off"
                  value={EdadSonrisaSocial}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d*$/.test(value)) {
                      setEdadSonrisaSocial(value);
                    }
                  }}
                  error={isvalid_EdadSonrisaSocial}
                  helperText={isvalid_EdadSonrisaSocial ? "Campo obligatorio *" : ""}
                  onFocus={() => {
                    isvalid_setEdadSonrisaSocial(false);
                    if (!EdadSostuvoCabeza) {
                      isvalid_setEdadSostuvoCabeza(true);
                    }
                    if (!EdadGateo) {
                      isvalid_setEdadGateo(true);
                    }
                    if (!EdadParo) {
                      isvalid_setEdadParo(true);
                    }
                    if (!EdadSento) {
                      isvalid_setEdadSento(true);
                    }
                    if (!EdadCamino) {
                      isvalid_setEdadCamino(true);
                    }
                    if (!EdadGiros) {
                      isvalid_setEdadGiros(true);
                    }
                    if (!EdadComio) {
                      isvalid_setEdadComio(true);
                    }
                    if (!EdadBano) {
                      isvalid_setEdadBano(true);
                    }
                  }}
                  onBlur={() => {
                    if (!EdadSonrisaSocial) isvalid_setEdadSonrisaSocial(true);
                  }}
                  style={{ width: "100%", marginBottom: "1rem" }}
                  inputProps={{
                    inputMode: "numeric", // Muestra teclado numérico en móviles
                    pattern: "[0-9]*", // Sugiere sólo números
                  }}
                />
              </Grid>
              <Grid item xs={12} md={4} lg={4}>
                <MDBox textAlign="right">
                  <MDTypography
                    variant="h6"
                    color="white"
                    style={{ opacity: 0.7, fontSize: "0.9rem" }}
                  >
                    Edad en la que comenzó a balbucear
                  </MDTypography>
                </MDBox>
              </Grid>
              <Grid item xs={12} md={4} lg={4}>
                <TextField
                  fullWidth
                  variant="outlined"
                  disabled={desactivar}
                  size="small"
                  autoComplete="off"
                  value={EdadBalbuceo}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d*$/.test(value)) {
                      setEdadBalbuceo(value);
                    }
                  }}
                  error={isvalid_EdadBalbuceo}
                  helperText={isvalid_EdadBalbuceo ? "Campo obligatorio *" : ""}
                  onFocus={() => {
                    isvalid_setEdadBalbuceo(false);
                    if (!EdadSostuvoCabeza) {
                      isvalid_setEdadSostuvoCabeza(true);
                    }
                    if (!EdadGateo) {
                      isvalid_setEdadGateo(true);
                    }
                    if (!EdadParo) {
                      isvalid_setEdadParo(true);
                    }
                    if (!EdadSento) {
                      isvalid_setEdadSento(true);
                    }
                    if (!EdadCamino) {
                      isvalid_setEdadCamino(true);
                    }
                    if (!EdadGiros) {
                      isvalid_setEdadGiros(true);
                    }
                    if (!EdadComio) {
                      isvalid_setEdadComio(true);
                    }
                    if (!EdadBano) {
                      isvalid_setEdadBano(true);
                    }
                    if (!EdadSonrisaSocial) {
                      isvalid_setEdadSonrisaSocial(true);
                    }
                  }}
                  onBlur={() => {
                    if (!EdadBalbuceo) isvalid_setEdadBalbuceo(true);
                  }}
                  style={{ width: "100%", marginBottom: "1rem" }}
                  inputProps={{
                    inputMode: "numeric", // Muestra teclado numérico en móviles
                    pattern: "[0-9]*", // Sugiere sólo números
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        {/* Edad primeras palabras / nombra objetos simples */}
        <Grid container spacing={2}>
          <Grid item xs={12} md={3} lg={3}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                Edad de las primeras palabras (leche, agua, mamá, papá) en caso de que lo haya hecho
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={9} lg={9}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={4} lg={4}>
                <TextField
                  fullWidth
                  variant="outlined"
                  disabled={desactivar}
                  size="small"
                  autoComplete="off"
                  value={EdadPrimerasPalabras}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d*$/.test(value)) {
                      setEdadPrimerasPalabras(value);
                    }
                  }}
                  error={isvalid_EdadPrimerasPalabras}
                  helperText={isvalid_EdadPrimerasPalabras ? "Campo obligatorio *" : ""}
                  onFocus={() => {
                    isvalid_setEdadPrimerasPalabras(false);
                    if (!EdadSostuvoCabeza) {
                      isvalid_setEdadSostuvoCabeza(true);
                    }
                    if (!EdadGateo) {
                      isvalid_setEdadGateo(true);
                    }
                    if (!EdadParo) {
                      isvalid_setEdadParo(true);
                    }
                    if (!EdadSento) {
                      isvalid_setEdadSento(true);
                    }
                    if (!EdadCamino) {
                      isvalid_setEdadCamino(true);
                    }
                    if (!EdadGiros) {
                      isvalid_setEdadGiros(true);
                    }
                    if (!EdadComio) {
                      isvalid_setEdadComio(true);
                    }
                    if (!EdadBano) {
                      isvalid_setEdadBano(true);
                    }
                    if (!EdadSonrisaSocial) {
                      isvalid_setEdadSonrisaSocial(true);
                    }
                    if (!EdadBalbuceo) {
                      isvalid_setEdadBalbuceo(true);
                    }
                  }}
                  onBlur={() => {
                    if (!EdadPrimerasPalabras) isvalid_setEdadPrimerasPalabras(true);
                  }}
                  style={{ width: "100%", marginBottom: "1rem" }}
                  inputProps={{
                    inputMode: "numeric", // Muestra teclado numérico en móviles
                    pattern: "[0-9]*", // Sugiere sólo números
                  }}
                />
              </Grid>
              <Grid item xs={12} md={4} lg={4}>
                <MDBox textAlign="right">
                  <MDTypography
                    variant="h6"
                    color="white"
                    style={{ opacity: 0.7, fontSize: "0.9rem" }}
                  >
                    Edad en la que nombra objetos simples (perro, carro, árbol), en caso de que lo
                    haya hecho
                  </MDTypography>
                </MDBox>
              </Grid>
              <Grid item xs={12} md={4} lg={4}>
                <TextField
                  fullWidth
                  variant="outlined"
                  disabled={desactivar}
                  size="small"
                  autoComplete="off"
                  value={EdadObjetosSimples}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d*$/.test(value)) {
                      setEdadObjetosSimples(value);
                    }
                  }}
                  error={isvalid_EdadObjetosSimples}
                  helperText={isvalid_EdadObjetosSimples ? "Campo obligatorio *" : ""}
                  onFocus={() => {
                    isvalid_setEdadObjetosSimples(false);
                    if (!EdadSostuvoCabeza) {
                      isvalid_setEdadSostuvoCabeza(true);
                    }
                    if (!EdadGateo) {
                      isvalid_setEdadGateo(true);
                    }
                    if (!EdadParo) {
                      isvalid_setEdadParo(true);
                    }
                    if (!EdadSento) {
                      isvalid_setEdadSento(true);
                    }
                    if (!EdadCamino) {
                      isvalid_setEdadCamino(true);
                    }
                    if (!EdadGiros) {
                      isvalid_setEdadGiros(true);
                    }
                    if (!EdadComio) {
                      isvalid_setEdadComio(true);
                    }
                    if (!EdadBano) {
                      isvalid_setEdadBano(true);
                    }
                    if (!EdadSonrisaSocial) {
                      isvalid_setEdadSonrisaSocial(true);
                    }
                    if (!EdadBalbuceo) {
                      isvalid_setEdadBalbuceo(true);
                    }
                    if (!EdadPrimerasPalabras) {
                      isvalid_setEdadPrimerasPalabras(true);
                    }
                  }}
                  onBlur={() => {
                    if (!EdadObjetosSimples) isvalid_setEdadObjetosSimples(true);
                  }}
                  style={{ width: "100%", marginBottom: "1rem" }}
                  inputProps={{
                    inputMode: "numeric", // Muestra teclado numérico en móviles
                    pattern: "[0-9]*", // Sugiere sólo números
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Grid container spacing={2}>
          {/* Contacto visual y dedo para señalar */}
          <Grid item xs={12} md={3} lg={3}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                ¿Tiene contacto visual?
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={9} lg={9}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={4} lg={4}>
                <Autocomplete
                  options={[
                    { label: "Sí", value: "1" },
                    { label: "No", value: "2" },
                  ]}
                  getOptionLabel={(option) => option.label}
                  disabled={desactivar}
                  id="ContactoVisual"
                  value={
                    [
                      { label: "Sí", value: "1" },
                      { label: "No", value: "2" },
                    ].find((opt) => opt.value == ContactoVisual) || null
                  }
                  onChange={(event, newValue) => {
                    setContactoVisual(newValue ? newValue.value : null);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      autoComplete="new-password"
                      label="Seleccione"
                      variant="outlined"
                      disabled={desactivar}
                      error={isvalid_ContactoVisual}
                      helperText={isvalid_ContactoVisual ? "Campo obligatorio *" : ""}
                      onFocus={() => {
                        isvalid_setContactoVisual(false);
                        if (!EdadSostuvoCabeza) {
                          isvalid_setEdadSostuvoCabeza(true);
                        }
                        if (!EdadGateo) {
                          isvalid_setEdadGateo(true);
                        }
                        if (!EdadParo) {
                          isvalid_setEdadParo(true);
                        }
                        if (!EdadSento) {
                          isvalid_setEdadSento(true);
                        }
                        if (!EdadCamino) {
                          isvalid_setEdadCamino(true);
                        }
                        if (!EdadGiros) {
                          isvalid_setEdadGiros(true);
                        }
                        if (!EdadComio) {
                          isvalid_setEdadComio(true);
                        }
                        if (!EdadBano) {
                          isvalid_setEdadBano(true);
                        }
                        if (!EdadSonrisaSocial) {
                          isvalid_setEdadSonrisaSocial(true);
                        }
                        if (!EdadBalbuceo) {
                          isvalid_setEdadBalbuceo(true);
                        }
                        if (!EdadPrimerasPalabras) {
                          isvalid_setEdadPrimerasPalabras(true);
                        }
                        if (!EdadObjetosSimples) {
                          isvalid_setEdadObjetosSimples(true);
                        }
                      }}
                      onBlur={() => {
                        if (ContactoVisual == null) isvalid_setContactoVisual(true);
                      }}
                    />
                  )}
                  style={{ width: "100%", marginBottom: "1rem" }}
                  size="small"
                />
              </Grid>
              <Grid item xs={12} md={4} lg={4}>
                <MDBox textAlign="right">
                  <MDTypography
                    variant="h6"
                    color="white"
                    style={{ opacity: 0.7, fontSize: "0.9rem" }}
                  >
                    ¿Usa dedo para señalar?
                  </MDTypography>
                </MDBox>
              </Grid>
              <Grid item xs={12} md={4} lg={4}>
                <Autocomplete
                  options={[
                    { label: "Sí", value: "1" },
                    { label: "No", value: "2" },
                  ]}
                  getOptionLabel={(option) => option.label}
                  disabled={desactivar}
                  id="DedoApuntar"
                  value={
                    [
                      { label: "Sí", value: "1" },
                      { label: "No", value: "2" },
                    ].find((opt) => opt.value == DedoApuntar) || null
                  }
                  onChange={(event, newValue) => {
                    setDedoApuntar(newValue ? newValue.value : null);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      autoComplete="new-password"
                      label="Seleccione"
                      variant="outlined"
                      disabled={desactivar}
                      error={isvalid_DedoApuntar}
                      helperText={isvalid_DedoApuntar ? "Campo obligatorio *" : ""}
                      onFocus={() => {
                        isvalid_setDedoApuntar(false);
                        if (!EdadSostuvoCabeza) {
                          isvalid_setEdadSostuvoCabeza(true);
                        }
                        if (!EdadGateo) {
                          isvalid_setEdadGateo(true);
                        }
                        if (!EdadParo) {
                          isvalid_setEdadParo(true);
                        }
                        if (!EdadSento) {
                          isvalid_setEdadSento(true);
                        }
                        if (!EdadCamino) {
                          isvalid_setEdadCamino(true);
                        }
                        if (!EdadGiros) {
                          isvalid_setEdadGiros(true);
                        }
                        if (!EdadComio) {
                          isvalid_setEdadComio(true);
                        }
                        if (!EdadBano) {
                          isvalid_setEdadBano(true);
                        }
                        if (!EdadSonrisaSocial) {
                          isvalid_setEdadSonrisaSocial(true);
                        }
                        if (!EdadBalbuceo) {
                          isvalid_setEdadBalbuceo(true);
                        }
                        if (!EdadPrimerasPalabras) {
                          isvalid_setEdadPrimerasPalabras(true);
                        }
                        if (!EdadObjetosSimples) {
                          isvalid_setEdadObjetosSimples(true);
                        }
                        if (ContactoVisual == null) {
                          isvalid_setContactoVisual(true);
                        }
                      }}
                      onBlur={() => {
                        if (DedoApuntar == null) isvalid_setDedoApuntar(true);
                      }}
                    />
                  )}
                  style={{ width: "100%", marginBottom: "1rem" }}
                  size="small"
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        {/* Comunicación que buscas para tu hijo */}
        <Grid container spacing={2}>
          <Grid item xs={12} md={3} lg={3}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                Comunicación que buscas para tu hijo
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={9} lg={9}>
            <Autocomplete
              options={[
                { label: "Oral", value: "1" },
                { label: "Lenguje o Señas", value: "2" },
              ]}
              getOptionLabel={(option) => option.label}
              disabled={desactivar}
              id="DedoApuntar"
              value={
                [
                  { label: "Oral", value: "1" },
                  { label: "Lenguje o Señas", value: "2" },
                ].find((opt) => opt.value == IdComunicacionBuscada) || null
              }
              onChange={(event, newValue) => {
                setIdComunicacionBuscada(newValue ? newValue.value : null);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  autoComplete="new-password"
                  label="Seleccione"
                  variant="outlined"
                  disabled={desactivar}
                  error={isvalid_IdComunicacionBuscada}
                  helperText={isvalid_IdComunicacionBuscada ? "Campo obligatorio *" : ""}
                  onFocus={() => {
                    isvalid_setIdComunicacionBuscada(false);
                    if (!EdadSostuvoCabeza) {
                      isvalid_setEdadSostuvoCabeza(true);
                    }
                    if (!EdadGateo) {
                      isvalid_setEdadGateo(true);
                    }
                    if (!EdadParo) {
                      isvalid_setEdadParo(true);
                    }
                    if (!EdadSento) {
                      isvalid_setEdadSento(true);
                    }
                    if (!EdadCamino) {
                      isvalid_setEdadCamino(true);
                    }
                    if (!EdadGiros) {
                      isvalid_setEdadGiros(true);
                    }
                    if (!EdadComio) {
                      isvalid_setEdadComio(true);
                    }
                    if (!EdadBano) {
                      isvalid_setEdadBano(true);
                    }
                    if (!EdadSonrisaSocial) {
                      isvalid_setEdadSonrisaSocial(true);
                    }
                    if (!EdadBalbuceo) {
                      isvalid_setEdadBalbuceo(true);
                    }
                    if (!EdadPrimerasPalabras) {
                      isvalid_setEdadPrimerasPalabras(true);
                    }
                    if (!EdadObjetosSimples) {
                      isvalid_setEdadObjetosSimples(true);
                    }
                    if (ContactoVisual == null) {
                      isvalid_setContactoVisual(true);
                    }
                    if (DedoApuntar == null) {
                      isvalid_setDedoApuntar(true);
                    }
                  }}
                  onBlur={() => {
                    if (IdComunicacionBuscada == null) isvalid_setIdComunicacionBuscada(true);
                  }}
                />
              )}
              style={{ width: "100%", marginBottom: "1rem" }}
              size="small"
            />
          </Grid>
        </Grid>

        {vista === "visualizar" ? null : (
          <MDBox textAlign="right">
            <Button
              variant="contained"
              onClick={() => ValidaForm()}
              sx={{ mt: 1, mr: 1 }}
              size="small"
              color="primary"
            >
              {"Continuar"}
            </Button>
            <Button
              variant="contained"
              disabled={false}
              onClick={() => handleBack()}
              sx={{ mt: 1, mr: 1 }}
              color="secondary"
              size="small"
            >
              Volver
            </Button>
          </MDBox>
        )}
      </>
    );
  }
);
export default DesarrolloMotor;
